module.exports = __webpack_public_path__ + "img/C2M智能定制banner1.9a6a9d77.png";